import * as React from 'react';
import { motion, useCycle } from 'framer-motion';
import { MenuToggle } from './MenuToggle';
import { Navigation } from './Navigation';

type NavConfig = {
  key: string;
  label: string;
  path: string;
  icon?: React.ReactNode;
};

const sidebar = {
  open: {
    clipPath: `circle(1200px at 40px 40px)`,
    transition: {
      stiffness: 20,
      restDelta: 2,
    },
  },
  closed: {
    clipPath: 'circle(30px at 40px 40px)',
    transition: {
      stiffness: 400,
      damping: 40,
      delay: 0.3,
    },
  },
};

export default function MobileMenuBar({ navConfigurations }: { readonly navConfigurations: ReadonlyArray<NavConfig> }) {
  const [isOpen, toggleOpen] = useCycle(false, true);
  return (
    <motion.nav initial={false} animate={isOpen ? 'open' : 'closed'}>
      <motion.div className="background" variants={sidebar} animate={isOpen ? 'open' : 'closed'} />
      <MenuToggle toggle={toggleOpen} isOpen={isOpen} />
      <Navigation navConfigurations={navConfigurations} toggle={toggleOpen} isOpen={isOpen} />
    </motion.nav>
  );
}
